import styled from '@emotion/styled';

export const CompanyLetterLogo = () => {
  return <Img alt="darum" src="/static/svg/company-letter-logo.svg" />;
};
const Img = styled.img`
  max-height: 30px;
`;
